import React, { useState } from "react";
import { UpOutlined } from "@ant-design/icons";
import "../TableCard/TableCard.scss";

const TableCard = ({
  fields = [],
  titleHeading,
  title,
  decisionType = "default",
  remark,
  remarkTitle="Remark",
  action,
  id,
  isRemark = false,
}) => {
  const [showRemark, setShowRemark] = useState(false);
  const [expandedKeys, setExpandedKeys] = useState({}); 

  const onToggleRemark = () => setShowRemark(!showRemark);

  const toggleField = (key) => {
    setExpandedKeys(prev => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <div className="table-card table-card-mobile-view" id={id}>
      {title && (
        <div className="table-card-header">
          <div>
            <div className="table-card-label">{titleHeading}</div>
            <div className="table-card-title ellipsis-single">{title}</div>
          </div>
          <div className="d-flex gap-1 align-items-center">
            <div>{action}</div>
          </div>
        </div>
      )}

      <div className="table-card-body">
        {fields
  .filter((f) => f.key !== "name")
  .map((field) => {
    const isExpanded = !!expandedKeys[field.key];

    if (field.collapsible && isExpanded) {
      return (
        <div className="table-card-row full-width-row" key={field.key}>
          <div
            className="full-width-content"
            onClick={() => toggleField(field.key)}
          >
            <div className="full-width-header">
              <span className={field?.collapsible ? "" : "fw-bold"}>{field.label}</span>
              <UpOutlined style={{ fontSize: 12 }} />
            </div>
            <div className="full-width-body">{field.value}</div>
          </div>
        </div>
      );
    }

    return (
            <div className="table-card-row" key={field.key}>
              <div className="table-card-label">{field.label}</div>
              <div className="table-card-cell value fw-bold ellipsis-single committee-submission-email-field">
          {field.collapsible
            ? typeof field.collapsedPreview === "function"
              ? field.collapsedPreview(isExpanded, () => toggleField(field.key))
              : field.collapsedPreview
            : field.value}
       </div>
      </div>
    )
})}
        {isRemark && (
          <>
            <div className="table-card-row remark-toggle" onClick={onToggleRemark}>
              <div className="table-card-label">{remarkTitle}</div>
              <div className="table-card-cell value remark-arrow ellipsis-single">
                {showRemark ? "▲" : "▼"}
              </div>
            </div>
            {showRemark && (
              <div className="table-card-remark">{remark ?? "-"}</div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default TableCard;
